import { render } from "./ProviderCard.vue?vue&type=template&id=71dd55a2&scoped=true&ts=true"
import script from "./ProviderCard.vue?vue&type=script&lang=ts"
export * from "./ProviderCard.vue?vue&type=script&lang=ts"

import "./ProviderCard.vue?vue&type=style&index=0&id=71dd55a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dd55a2"]])

export default __exports__